const RoleUtils = {
  STAFF: 'STAFF',
  BIOMETRIC_OFFICER: 'BIOMETRIC_OFFICER',
  FACULTY_OFFICER: 'FACULTY_OFFICER',
  DEAN: 'DEAN',
  HEAD: 'HEAD',
  DIRECTOR: 'DIRECTOR',
  REGISTRAR: 'REGISTRAR',
  VC: 'VC',
  ADMIN: 'ADMIN',
  SUPER_ADMIN: 'SUPER_ADMIN',
  A_AND_PC: 'A_AND_PC',

  contains: (roles: any, role: any) => {
    return roles.includes(role)
  },

  deepContains: (mRoles: any, uRoles: any) => {
    for (let i = 0; i < uRoles.length; i++) {
      for (let j = 0; j < mRoles.length; j++){
        if(uRoles[i] === mRoles[j])
          return true
      }
    }
    return false
  }
}

export default RoleUtils
